<template>
  <div class="container-fluid home find-employee top-75">
    <div class="latest-jobs latest-jobs1">
      <!-- <h1 class="text-center job-header" v-if="userSkills">
        Hire {{ userSkills }} Worker
      </h1>
      <br /> -->
      <Loader :isLoader="loadingBtn" />
      <div class="row px-0">
        <div :class="mapCity ? 'col-md-4' : 'col-md-12 map-bg'" class="px-0" id="resumeList">
          <div id="leftSideBar" class="leftSideBar" :style="{ height: mapCity ? '100vh' : 'auto' }">
            <div class="
                d-flex
                align-items-center
                justify-content-between
                px-2
                jobs-fixedHeader
              ">
              <h4 class="jobs-title" v-if="userSkills">
                Hire {{ userSkills }} Worker {{ !loadingBtn ? ( totalCount ? '('+ totalCount +')':'' ): ''  }}
              </h4>
              <img @click="toggleFilter" src="@/assets/images/filter.svg" alt="filter" class="mt-4" />
            </div>
            <div id="filterPopup" class="modalContent" :style="{ display: showFilter ? 'block' : 'none' }">
              <div class="filterPopup--content">
                <div class="filterPopup--block">
                  <div class="px-2">
                    <input type="text" class="form-control jobs-search-input" id="skillProfile"
                      placeholder="Search profile" aria-describedby="inputGroupPrepend3" v-model="skillKeyword"
                      v-on:input="onChangeKeySkill" />
                  </div>
                  <ul>
                    <li v-for="skill in skillListData" :key="skill._id">
                      <span :class="{
                        active: selectedSkillsList.includes(skill.name),
                      }" @click="onSelectSkill(skill.name)">
                        {{ skill.name }}
                      </span>
                    </li>
                  </ul>
                  <input type="text" class="form-control jobs-search-input" id="city" placeholder="Search City"
                    aria-describedby="inputGroupPrepend3" v-model="searchKeyword" v-on:input="onChangeCity" />
                  <ul>
                    <li v-for="city in cityListData" :key="city._id" @click="onSelectCity(city.location)">
                      <span :class="{ active: selectedCity === city['location'] }">{{ city.location }}
                      </span>
                    </li>
                  </ul>
                  <div class="col-12 mb-2">
                    <button class="btn btn-info" v-if="!loadingBtn" @click="searchResume">
                      <i class="fa fa-search"></i>Search
                    </button>
                    <button class="btn btn-info" v-else>
                      loading <b-spinner label="Loading..."></b-spinner>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="float--toggle" @click="isToggleOpen = !isToggleOpen" :class="{ open: isToggleOpen }">
              <img src="@/assets/images/menu.svg" alt="" height="25" width="25" className="icon" />
            </div>
            <div v-if="listArray.length" class="card bg-transparent mt-jobs-fixedHeader" :class="{ open: isToggleOpen }">
              <div class="card-body" style="padding: 1.25rem 0px">
                <div v-if="listArray.length && mapCity" class="card-container">
                  <ToggleCard v-for="info in listArray" :key="info._id" :info="info" :openCard="openCard"
                    :showMobile="showMobile" :showCallback="showCallback" :showWhatsapp="showWhatsapp"
                    dateTitle="Active On" :userSkills="userSkills" :userLocation="mapCity"
                    @view="(id, info) => onViewEmployeProfile(id, info)" :viewed="viewedUserList.includes(info.user)"
                    @mobile="(id, info) => onViewMobile(id, info)" @callback="(id, info) => getCallback(id, info)"
                    @whatsapp="(id, info) => getWhatsappLink(id, info)" :notify="notify" @hideNotify="hideNotify()" />
                </div>
                <div v-if="listArray.length && !mapCity" class="card-container">
                  <ToggleCard v-for="info in listArray" :key="info._id" :info="info" :openCard="openCard"
                    dateTitle="Active On" :userSkills="userSkills" :userLocation="mapCity" dateKey="updatedAt"
                    :showMobile="showMobile" :showCallback="showCallback" :showWhatsapp="showWhatsapp"
                    @view="(id, info) => onViewEmployeProfile(id, info)" :viewed="viewedUserList.includes(info.user)"
                    @mobile="(id, info) => onViewMobile(id, info)" @callback="(id, info) => getCallback(id, info)"
                    @whatsapp="(id, info) => getWhatsappLink(id, info)" :notify="notify" @hideNotify="hideNotify()" />
                </div>
                <div v-else-if="listArray.length == 0 && !loadingBtn">
                  <h5 class="text-center">No Resume Found</h5>
                </div>
              </div>
              <div v-if="!loadingBtn" class="pagination-block px-1 mb-2">
                <el-pagination v-if="listArray.length > 0" background layout="prev, pager, next" :page-size="40"
                  :current-page="this.pageNum" :total="totalCount" @current-change="this.onPageChange">
                </el-pagination>
                <!-- <div v-if="getPageStatus()">
                  <button @click="this.loadMore" class="load-more-btn">
                    Load More Similar Profile Resumes...
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <FreeResumeExhausted
          :showModal="freeResumeExhusted"
          @close="closeFreeExhaustModal"
        /> -->
        <div v-if="mapCity" class="col-md-8 rightContent px-0" style="height: 100vh">
          <AddGoogleMap v-if="mapCity && this.listArray.length > 0" :city="mapCity" :totalCount="this.listArray.length" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import { APIService } from "@/service/api.js";
import urlConstant from "@/constants/uri.constants.js";
import ToggleCard from "../components/common/ToggleCard.vue";
import "@/assets/css/latest-jobs.css";
import AddGoogleMap from "../components/AddGoogleMap.vue";
import Loader from "../components/common/Loader.vue"
import { useHead } from '@vueuse/head'

export default {
  name: "SearchResumeList",
  components: {
    AddGoogleMap,
    ToggleCard,
    Loader,
  },
  // setup() {
  //   useHead({
  //     title: `Required ${this.stringMan(this.$route.params.skill)} Workers${this.$route.params.location
  //       ? " in " + this.stringMan(this.$route.params.location)
  //       : ""
  //       }?
  //      Hire Staff on Theincircle`,
  //     meta: [
  //       {
  //         name: "description",
  //         content: `Want to hire ${this.stringMan(
  //           this.$route.params.skill
  //         )} workers in ${this.$route.params.location
  //           ? this.stringMan(this.$route.params.location)
  //           : "India"
  //           } ? Post your requirements on TheIncircle Website and hire ${this.stringMan(
  //             this.$route.params.skill
  //           )} staff online for the factory and company today directly.`, // Post a Job free on Theincircle.com Website and hire Candidates online in 3 Days in India. No.1 Job Site for finding Employees for Factories and Industry.
  //       },
  //       {
  //         property: "og:title",
  //         content: `Hire Staff in India | Get Candidates on Theincircle`,
  //       },
  //       { property: "og:url", content: window.location.href },
  //       {
  //         property: "og:description",
  //         content: `Looking to hire for ${this.stringMan(
  //           this.$route.params.skill
  //         )} Staff in ${this.$route.params.location
  //           ? this.stringMan(this.$route.params.location)
  //           : "India"
  //           } ? Post a Job free on Theincircle.com Website and hire Candidates online in 3 Days in India. No.1 Job Site for finding Employees for Factories and Industry.`,
  //       },
  //     ],
  //     link: [{ rel: "canonical", href: window.location.href }],
  //   })
  // },
  data() {
    return {
      // freeResumeExhusted: false,
      filter: false,
      showMobileOrDetails: 1,
      notify: false,
      openCard: {},
      showMobile: {},
      showCallback: {},
      showWhatsapp: {},
      showFilter: false,
      mapCity: "",
      isToggleOpen: false,
      parent: {},
      posts: [],
      page: 1,
      skillKeyword: "",
      searchKeyword: "",
      localityKeyword: "",
      skillListData: [],
      cityListData: [],
      perPage: 40,
      pageNum: 1,
      totalCount: 0,
      pages: [],
      locations: [],
      locality: [],
      skills: [],
      viewedUserList: [],
      userSkills: "",
      loadingBtn: false,
      selectedLocality: "",
      selectedGender: "",
      selectedQualification: "",
      selectedSkills: "",
      selectedSkillsList: [],
      selectedResumeList: [],
      wholeList: [],
      employerProfileData: null,
      listArray: [],
      selectedCity: "",
      mobFilterToggle: "sideFixed",
      genderArray: [
        {
          gender: "Male",
          id: "1",
        },
        {
          gender: "Female",
          id: "2",
        },
        {
          gender: "Both",
          id: "0",
        },
      ],
      educations: [
        "Education",
        "10 or Below",
        "10+2 or above",
        "Diploma",
        "Graduation",
        "Post Graduation",
        "PhD",
      ],
      Cookies: Cookies,
    };
  },
  created() {
    this.getPosts();
  },
  computed: {
    ...mapState({
      findResumeData: (state) => state.GeneralModule.findResumeData,
      skillList: (state) => state.GeneralModule.suggestedSkill,
      cityList: (state) => state.GeneralModule.cityList,
      viewResumeMobile: (state) => state.GeneralModule.viewResumeMobile,
      getResumeCallback: (state) => state.GeneralModule.getResumeCallback,
      viewWhatsapp: (state) => state.GeneralModule.viewWhatsapp,
      allSkillsList: (state) => state.GeneralModule.skillList,
      // jobDetail: (state) => state.GeneralModule.jobDetail,
      allLocations: (state) => state.GeneralModule.allLocations,
      employerProfile: (state) => state.EmployerModule.employerProfile,
      allLocality: (state) => state.GeneralModule.localityList,
    }),
    resumeListData() {
      // console.log('---this.post--', this.posts.length)
      return this.posts ? this.paginate(this.posts) : null;
    },
  },
  filters: {
    trimWords(value) {
      return (
        value
          .split(" ")
          .splice(0, 20)
          .join(" ") + "..."
      );
    },
  },
  watch: {
    posts() {
      this.setPages();
    },
    employerProfile() {
      if (!this.employerProfile.isFechingProfile) {
        if (this.employerProfile.responseData.status === 200) {
          this.employerProfileData = this.employerProfile.responseData.data.employer;
        }
      }
    },
    viewResumeMobile() {
      if (this.viewResumeMobile?.responseData?.status === 200) {
        if (this.viewResumeMobile?.responseData?.data?.userContact) {
          const user_data = this.viewResumeMobile.responseData.data
            ?.userContact;
          this.showMobileHandler(user_data?._id, user_data?.user?.mobile);
        }
      } else if (
        this.viewResumeMobile?.responseData?.status === 404 ||
        this.viewResumeMobile?.responseData?.status === 204
      ) {
        if (Cookies.get("authToken")) {
          this.notify = { [this.viewResumeMobile.id]: 1 };
          this.showMobile = {};
        } else {
          this.showMobile = {};
          this.setCurrPath();
          this.$router.push("/login");
        }
      }
    },
    getResumeCallback() {
      if (this.getResumeCallback?.responseData?.status === 200) {
        this.showCallbackHandler(this.getResumeCallback.id, true);
      } else if (
        this.getResumeCallback?.responseData?.status === 404 ||
        this.getResumeCallback?.responseData?.status === 204
      ) {
        if (Cookies.get("authToken")) {
          this.notify = { [this.getResumeCallback.id]: 2 };
          this.showCallback = {};
        } else {
          this.showCallback = {};
          this.setCurrPath();
          this.$router.push("/login");
        }
      }
    },
    viewWhatsapp() {
      if (this.viewWhatsapp?.responseData?.status === 200) {
        const link = this.viewWhatsapp?.responseData?.data?.whatsAppLink;
        if (link) {
          window.open(link);
        }
        this.showWhatsapp = {};
      } else if (
        this.viewWhatsapp?.responseData?.status === 404 ||
        this.viewWhatsapp?.responseData?.status === 204
      ) {
        if (Cookies.get("authToken")) {
          this.notify = { [this.viewWhatsapp.id]: 3 };
          this.showWhatsapp = {};
        } else {
          this.showWhatsapp = {};
          this.$router.push("/login");
        }
      }
    },
    findResumeData() {
      this.loadingBtn = true;
      // console.log('--watch--',this.findResumeData);
      if (!this.findResumeData.isFetchinResume) {
        if (this.findResumeData.responseData?.records) {
          this.loadingBtn = false;
          this.wholeList = this.findResumeData.responseData;
          // console.log("whole", this.wholeList)
          this.listArray = this.wholeList.records;
          // this.listArray = this.wholeList.records.splice(0, 10);
          // this.listArray.map((a)=>{console.log("user ID",a.user._id, "_id",a._id)})
          this.perPage = 40;
          this.totalCount = this.findResumeData.responseData.totalCount;
          this.parent = this.findResumeData.responseData.parent;
          if (this.findResumeData.responseData.records.length > 0) {
            this.setData();
          }
          if (this.filter) {
            this.loadMore();
          }
        } else if (
          this.findResumeData.responseData.message == "Records not found" &&
          !!this.findResumeData.responseData.parent
        ) {
          let link;
          ``;
          let skill = this.$route.params.skill
            .split("-")
            .map((s) => {
              return s.charAt(0).toUpperCase() + s.slice(1);
            })
            .join(" ");
          let city = this.$route.params.location
            ? this.$route.params.location.charAt(0).toUpperCase() +
            this.$route.params.location.slice(1)
            : "";

          let newSkill = this.findResumeData.responseData.parent.name;
          let splitSkills = newSkill.split(" ").join("-");
          splitSkills = splitSkills.toLowerCase();
          if (splitSkills !== "" && city !== "" && skill !== newSkill) {
            link = `/hire-${splitSkills}-in-${city}`;
          } else if (skill == newSkill) {
            link = `/hire-${splitSkills}`;
          }

          this.$router.push(link);
          this.getData();
          this.mapCity = this.$route.params.location;
        } else if (this.findResumeData.responseData.statusCode === 404) {
          // if (Cookies.get("authToken")) {
          this.$router.push("/");
          // } else {
          // this.$router.push("/login");
          // }
          // window.location.href = "https://www.theincircle.com/404";
          //  this.$router.push("/");
          this.loadingBtn = false;
        } else {
          this.loadingBtn = false;
          this.$message({
            message: this.findResumeData.responseData.message,
            type: "error",
            offset: 80,
          });
        }
      }
      // else {
      //   setTimeout(() => {
      //     if (this.listArray.length == 0) {
      //       this.loadingBtn = false;
      //       this.$message({
      //         message: "No Records found.",
      //         type: "error",
      //         offset: 80,
      //       });
      //     }
      //   }, 5000);
      // }
    },
    // allSkillsList() {
    //   // console.log('--watch--',this.allSkillsList);
    //   if (!this.allSkillsList.isFetchinResume) {
    //     if (this.allSkillsList.responseData.status === 200) {
    //       this.skills = this.allSkillsList.responseData.data.skills;
    //     }
    //   }
    // },
    cityList() {
      if (!this.cityList.isFechingCities) {
        this.cityListData = this.cityList.responseData;
      }
    },
    skillList() {
      if (!this.skillList.isFechingSkills) {
        this.skillListData = this.skillList.responseData;
        const skillData = [];
        this.skillListData.forEach((item) => {
          const skillCode = item.name.split(" ").join("-");
          skillData.push({
            _id: item._id,
            name: item.name,
            code: skillCode,
          });
        });
        this.skillListData = skillData;
      }
    },
    allSkillsList() {
      if (!this.allSkillsList.isFechingSkills) {
        this.filterResults = this.allSkillsList.responseData;
        const skillData = [];
        this.filterResults.forEach((item) => {
          const skillCode = item.name.split(" ").join("-");
          skillData.push({
            _id: item._id,
            name: item.name,
            code: skillCode,
          });
        });
        this.skillListData = skillData;
      }
    },
    allLocations() {
      if (!this.allLocations.isFetchinResume) {
        if (this.allLocations.responseData.status === 200) {
          this.locations = this.allLocations.responseData.data?.locations;
        }
      }
    },
    allLocality() {
      if (!this.allLocality.isFechingLocalities) {
        if (this.allLocality.responseData) {
          // console.log("this", this.allLocality);
          this.locality = this.allLocality.responseData;
        }
      }
    },
    listArray() {
      // console.log(this.listArray);
    },
  },
  beforeMount() {
    this.getData();
  },
  mounted() {
    useHead({
      title: `Required ${this.stringMan(this.$route.params.skill)} Workers${this.$route.params.location
        ? " in " + this.stringMan(this.$route.params.location)
        : ""
        }?
       Hire Staff on Theincircle`,
      meta: [
        {
          name: "description",
          content: `Want to hire ${this.stringMan(
            this.$route.params.skill
          )} workers in ${this.$route.params.location
            ? this.stringMan(this.$route.params.location)
            : "India"
            } ? Post your requirements on TheIncircle Website and hire ${this.stringMan(
              this.$route.params.skill
            )} staff online for the factory and company today directly.`, // Post a Job free on Theincircle.com Website and hire Candidates online in 3 Days in India. No.1 Job Site for finding Employees for Factories and Industry.
        },
        {
          property: "og:title",
          content: `Hire Staff in India | Get Candidates on Theincircle`,
        },
        { property: "og:url", content: window.location.href },
        {
          property: "og:description",
          content: `Looking to hire for ${this.stringMan(
            this.$route.params.skill
          )} Staff in ${this.$route.params.location
            ? this.stringMan(this.$route.params.location)
            : "India"
            } ? Post a Job free on Theincircle.com Website and hire Candidates online in 3 Days in India. No.1 Job Site for finding Employees for Factories and Industry.`,
        },
      ],
      link: [{ rel: "canonical", href: window.location.href }],
    })
    localStorage.removeItem("listingPagePrevPath");
    this.$store.dispatch("EmployerModule/actionEmployerProfile");
    const skill = this.$route.params.skill
      .split("-")
      .map((s) => {
        return s.charAt(0).toUpperCase() + s.slice(1);
      })
      .join(" ");
    this.userSkills = skill;
    this.$store.dispatch(
      "GeneralModule/actionSearchSuggestedSkill",
      skill || ""
    );
    this.mapCity = this.$route.params.location;
    this.locations = this.allLocations.responseData?.data?.locations;
    this.locality = this.allLocality.responseData;
    this.setData();
    this.onChangeCity({ target: { value: "" } });
    if (this.mapCity) this.onSelectCity(this.mapCity);
    this.isToggleOpen = true;
    this.scrollTop();
  },
  methods: {
    closeFreeExhaustModal() {
      this.openCard = {};
    },
    hideNotify() {
      this.notify = false;
    },
    setCurrPath() {
      localStorage.setItem("listingPagePrevPath", this.$route.path);
    },
    getData() {
      let resumeObj = {
        skill: this.$route.params.skill
          .split("-")
          .map((s) => {
            return s.charAt(0).toUpperCase() + s.slice(1);
          })
          .join(" "),
        city: this.$route.params.location
          ? this.$route.params.location.charAt(0).toUpperCase() +
          this.$route.params.location.slice(1)
          : "",
        page: this.pageNum,
        findResume: true,
      };
      this.$store.dispatch("GeneralModule/findResume", resumeObj);
      // this.$store.dispatch("GeneralModule/actionFetchAddSkills", resumeObj);
      // this.scrollTop()
    },
    getMoreData(skill, city) {
      let resumeObj = {
        skill: skill,
        city: city,
        page: this.pageNum,
      };
      this.$store.dispatch("GeneralModule/findResume", resumeObj);
    },
    getPageStatus() {
      let totalPage = this.totalCount / this.perPage;
      totalPage = Math.ceil(totalPage);
      if (totalPage === this.pageNum) {
        return true;
      } else {
        return false;
      }
    },
    showMobileHandler(id, data) {
      this.showMobile = {
        ...this.showMobile,
        [id]:
          data === "load"
            ? data
            : this.showMobile[id] === "load" || !this.showMobile[id]
              ? data
              : false,
      };
    },
    showCallbackHandler(id, data) {
      this.showCallback = {
        ...this.showCallback,
        [id]:
          data === "load"
            ? data
            : this.showCallback[id] === "load" || !this.showCallback[id]
              ? data
              : false,
      };
    },
    showWhatsappHandler(id, data) {
      this.showWhatsapp = {
        ...this.showWhatsapp,
        [id]:
          data === "load"
            ? data
            : this.showWhatsapp[id] === "load" || !this.showWhatsapp[id]
              ? data
              : false,
      };
    },
    async onViewMobile(_id, info) {
 
      const jwtToken = Cookies.get("authToken");
      if (!jwtToken) this.$router.push("./login");

      if (this.showMobile[_id]?.toString()?.length === 10) {
        document.location.href = `tel:+91${this.showMobile[_id]}`;
        setTimeout(() => {
          this.showMobileHandler(_id, false);
        }, 10000);
        return;
      }
      else {
        this.showMobileHandler(_id, "load");
        const { status, data } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
          "viewType": "resume",
          "type": "mobile",
          "id": _id
        });
        if (status !== 200) {
          this.$router.push("/database-new");
        }
        else {
          if (data?.dataObject?.userDetails) {
            const user_data = data?.dataObject?.userDetails;
            this.showMobileHandler(user_data?._id, user_data?.mobile);
          }
        }
        let employerId = Cookies.get("userId");
        // eslint-disable-next-line no-undef
        nv("event", "View Resume", {
          //View Mobile
          employerID: employerId,
          name:
            this.employerProfileData?.contactPerson || "Employer Not Logged In",
          companyName:
            this.employerProfileData?.companyName || "Employer Not Logged In",
          email:
            this.employerProfileData?.emailAddress || "Employer Not Logged In",
          jobProfile: this.userSkills,
          jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
          jobSeekerProfile: info.profile ? info.profile.name : "",
          jobSeekerLocation: info.workLocality
            ? info.workLocality?.city
            : info.workLocation?.city,
          url: window.location.href,
        });
      }
    },
    async getCallback(_id, info) {

      const jwtToken = Cookies.get("authToken");
      if (!jwtToken) this.$router.push("./login");

      this.showCallbackHandler(_id, "load");
      const { status } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
        "viewType": "resume",
        "type": "callback",
        "id": _id
      });
      if (status !== 200) {
        this.$router.push("/database-new");
      }
      else {
        // console.log(info);
        if (this.showCallback[_id] !== "load") {
          this.showCallbackHandler(_id, false);
          return;
        } else {
          this.showCallbackHandler(_id, true);
        }
      }
      let employerId = Cookies.get("userId");
      // eslint-disable-next-line no-undef
      nv("event", "View Resume", {
        //get call back
        employerID: employerId,
        name:
          this.employerProfileData?.contactPerson || "Employer Not Logged In",
        companyName:
          this.employerProfileData?.companyName || "Employer Not Logged In",
        email:
          this.employerProfileData?.emailAddress || "Employer Not Logged In",
        jobProfile: this.userSkills,
        jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
        jobSeekerProfile: info.profile ? info.profile.name : "",
        jobSeekerLocation: info.workLocality
          ? info?.workLocality?.city
          : info?.workLocation?.city,
        url: window.location.href,
      });
      // this.$store.dispatch("GeneralModule/actionGetResumeCallback", {
      //   id: _id,
      // });
    },
    async getWhatsappLink(_id, info) {
      const jwtToken = Cookies.get("authToken");
      if (!jwtToken) this.$router.push("./login");
      
      this.showWhatsappHandler(_id, "load");
      const { status, data } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
        "viewType": "resume",
        "type": "whatsapp",
        "id": _id
      });
      if (status !== 200) {
        this.$router.push("/database-new");
      } else {
        const link = data?.dataObject?.userDetails?.whatsappLink;
        if (link) {
          window.open(link);
        }
        this.showWhatsapp = {};
      }
      let employerId = Cookies.get("userId");
      // eslint-disable-next-line no-undef
      nv("event", "View Resume", {
        //View Mobile
        employerID: employerId,
        name:
          this.employerProfileData?.contactPerson || "Employer Not Logged In",
        companyName:
          this.employerProfileData?.companyName || "Employer Not Logged In",
        email:
          this.employerProfileData?.emailAddress || "Employer Not Logged In",
        jobProfile: this.userSkills,
        jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
        jobSeekerProfile: info.profile ? info.profile.name : "",
        jobSeekerLocation: info.workLocality
          ? info?.workLocality?.city
          : info?.workLocation?.city,
        url: window.location.href,
      });
    },
    loadMore() {
      let skill = this.parent.name;
      let cityCap;
      if (this.filter) {
        this.filter = false;
        cityCap = this.selectedCity;
      } else {
        cityCap = this.$route.params.location
          ? this.$route.params.location.charAt(0).toUpperCase() +
          this.$route.params.location.slice(1)
          : "";
      }
      let link;
      let splitSkills = skill.split(" ").join("-");
      splitSkills = splitSkills.toLowerCase();
      let city = cityCap.toLowerCase();
      if (splitSkills !== "" && city !== "") {
        link = `/hire-${splitSkills}-in-${city}`;
      } else if (city == "") {
        link = `/hire-${splitSkills}`;
      }
      this.$router.push(link);
      this.pageNum = 1;
      this.getMoreData(skill, cityCap);
    },
    onPageChange(evt) {
      this.pageNum = evt;
      this.getData();
      // this.findResumeData();
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedResumeList = this.listArray.map((r) => {
          return r.user._id;
        });
      } else {
        this.selectedResumeList = [];
      }
    },
    selectResume(resumeId, event) {
      if (event.target.checked) {
        this.selectedResumeList.push(resumeId);
      } else {
        this.selectedResumeList = this.selectedResumeList.filter(
          (r) => r !== resumeId
        );
      }
    },
    checkAllSelected() {
      let notInList = 0;
      this.listArray.forEach((r) => {
        if (!this.selectedResumeList.includes(r.id)) {
          notInList++;
        }
      });
      return !notInList ? true : false;
    },
    downloadExcel() {
      if (!this.selectedResumeList.length) {
        return;
      }
      const jwtToken = Cookies.get("authToken");
      const userId = Cookies.get("userId");
      APIService.post(
        urlConstant.baseUrl + urlConstant.downloadResumeExcel,
        { ids: this.selectedResumeList },
        { headers: { jwt: jwtToken, userid: userId } }
      )
        .then((res) => {
          if (res.data) {
            // console.log(res.data);
            if (res.data.data.excel != undefined) {
              window.open(
                urlConstant.baseUrl + "/" + res.data.data.excel,
                "_blank"
              );
            } else {
              this.$message({
                message: res.data.data.message,
                type: "error",
                offset: 100,
              });
            }
          }
        })
        .catch((err) => {
          console.log("downloadFileErr", err);
        });
    },
    onChangeKeySkill(e) {
      // this.$store.dispatch(
      //   "GeneralModule/actionSearchSuggestedSkill",
      //   e.target.value
      // );
      if (e.target.value.length == 0) {
        const skill = this.$route.params.skill
          .split("-")
          .map((s) => {
            return s.charAt(0).toUpperCase() + s.slice(1);
          })
          .join(" ");
        // console.log("skil:  ", skill);
        this.$store.dispatch(
          "GeneralModule/actionSearchSuggestedSkill",
          skill || ""
        );
      } else {
        this.$store.dispatch("GeneralModule/actionSearchSkill", e.target.value);
      }
    },
    setData() {
      // const { skillObjs } = this.$store.state.GeneralModule;
      // this.userSkills = skillObjs?.responseData?.skill;
      let resumeData = [];
      if (!this.findResumeData.isFetchinResume) {
        resumeData = this.findResumeData.responseData?.records;
        this.viewedUserList = this.findResumeData.responseData?.usersIds;
      }
      resumeData.forEach((element) => {
        const updatedAt = new Date(element.updatedAt).toLocaleDateString({
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
        this.resumeListData.push({
          name: element.basicInfo.name,
          city: element.workLocation ? element.workLocation.location : "",
          locality: element.workLocality?.location,
          profile: element.profile ? element.profile.name : "",
          salary: element.currentSalary,
          qualification: element.qualification,
          skills: element.skills,
          experience: element.experience,
          updatedAt: updatedAt,
          gender: element.basicInfo.gender,
          age: element.basicInfo.age,
          id: element.user ? element.user._id : "",
        });
      });
      this.posts = this.resumeListData;
      this.scrollTop();
    },
    onChangeCity(e) {
      this.$store.dispatch("GeneralModule/fetchCitySearchList", e.target.value);
    },
    onSelectSkill(skillName) {
      // this.selectedSkills = skillName;
      if (this.selectedSkillsList.includes(skillName)) {
        this.selectedSkillsList = this.selectedSkillsList.filter(
          (s) => s !== skillName
        );
      } else {
        this.selectedSkillsList.push(skillName);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString({
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
    },
    onSelectLocal(locality) {
      this.selectedLocality = locality;
    },
    onSelectCity(cityName) {
      cityName = cityName.charAt(0).toUpperCase() + cityName.slice(1);
      this.selectedCity = cityName;
      const cityObj = {
        city: cityName,
        keyword: "",
        // keyword: 'SEARCH_LOCALITY',
      };
      this.$store.dispatch("GeneralModule/fetchLocalitySearchList", cityObj);
    },
    getPosts() {
      this.posts = this.resumeListData;
      // console.log('--data-post--', this.posts)
    },
    setPages() {
      let numberOfPages = Math.ceil(this.posts.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
      // console.log('--pages--', this.pages)
    },
    paginate(posts) {
      // console.log('--pages--', posts)
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return posts.slice(from, to);
    },
    getSelectedCity() {
      // const cityObj = {
      //   city: selected,
      //   keyword: '',
      //   // keyword: 'SEARCH_LOCALITY',
      // }
      // this.$store.dispatch("GeneralModule/fetchLocalitySearchList", cityObj);
    },
    getSelectedLocality(locality) {
      // console.log("selectLocality", locality);
      this.selectedLocality = locality;
    },
    // check employer profile on viw click
    async onViewEmployeProfile(empId, data) {
      if (!this.openCard[empId])
        this.openCard = { ...this.openCard, [empId]: "load" };
      let employerId = Cookies.get("userId");
      const jwtToken = Cookies.get("authToken");

      if (!jwtToken) this.$router.push("./login");
      let self = this;
      // eslint-disable-next-line no-undef
      nv("event", "View Resume", {
        employerID: employerId,
        jobId: data?._id,
        name: data?.basicInfo?.name,
        email: data?.email,
        mobile: data?.mobile,
        jobProfile: data?.profile?.name,
        location: data?.workLocation
          ? data?.workLocation?.city || ""
          : data?.workLocality
            ? data?.workLocality?.city || ""
            : "",
        companyName:
          self.employerProfileData?.companyName || "Employer Not Logged In",
        empName:
          self.employerProfileData?.contactPerson || "Employer Not Logged In",
        empNumber: self.employerProfileData?.contactNumber || null,
        empEmail:
          self.employerProfileData?.emailAddress || "Employer Not Logged In",
        url: window.location.href,
      });

      if (jwtToken && empId) {
        try {
          const { status, data } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
            "viewType": "resume",
            "type": "details",
            "id": empId
          });
          if (status === 200) {
            this.openCard = {
              ...this.openCard,
              [empId]:
                this.openCard[empId] === "load" || !this.openCard[empId]
                  ? data?.dataObject?.userDetails
                  : false,
            };
          }
          if (status !== 200) {
            let arr = [];
            let sample = [
              { name: "Rahul Sharma", profile: "Machine Operator" },
              { name: "Ashish Yadav", profile: "Constructor" },
              { name: "Vishal Tripathi", profile: "Tailor" },
            ];
            for (let i = 0; i < 3; i++) {
              if (this.listArray[i].basicInfo && this.listArray[i].profile) {
                arr.push({
                  name: this.listArray[i].basicInfo.name || sample[i].name,
                  profile: this.listArray[i].profile.name || sample[i].profile,
                });
              } else {
                arr.push({
                  name: sample[i].name,
                  profile: sample[i].profile,
                });
              }
            }
            var now = new Date();
            var time = now.getTime();
            var expireTime = time + 3600 * 1000 * 2 * 1 * 1;
            now.setTime(expireTime);
            Cookies.set("databaseTemp", JSON.stringify(arr), {
              path: "/",
              expires: now,
            });
            this.$router.push("/database-new");
          }
          if (status === 404) {
            if (Cookies.get("authToken")) {
              this.$router.push("/");
            } else {
              this.$router.push("/login");
              this.setCurrPath();
            }
          }
        } catch (error) {
          this.$router.push("/login");
          this.setCurrPath();
        }
      } else {
        this.$router.push("/login");
        this.setCurrPath();
      }
    },
    scrollTop() {
      document.getElementById("leftSideBar").scrollTop = 0;
    },
    searchResume() {
      let defaultCity = this.stringMan(
        this.$route.params.location ? this.$route.params.location : ""
      );
      let defaultSkill = this.stringMan(
        this.$route.params.skill ? this.$route.params.skill : ""
      );
      const _obj = {
        // locality: this.selectedLocality,
        skill:
          this.selectedSkillsList.length > 0
            ? this.selectedSkillsList.join(",")
            : defaultSkill,
        city: this.selectedCity ? this.selectedCity : defaultCity,
        // qualification: this.selectedQualification,
        // gender: this.selectedGender,
      };
      if (this.selectedSkillsList.length > 0 || this.selectedCity) {
        this.filter = true;
        this.$store.dispatch("GeneralModule/findResume", _obj);
        // _obj['page'] = this.pageNum;
        // this.$store.dispatch("GeneralModule/actionFetchAddSkills", _obj);
      }
      this.mobFilterToggle = "sideFixed";
      this.mapCity = this.selectedCity ? this.selectedCity : defaultCity;
      this.showFilter = false;
      window.scrollTo(0, 0);
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter) this.scrollTop();
    },
    stringMan(str) {
      const finalOutput = str
        .split("-")
        .map((s) => {
          return s.charAt(0).toUpperCase() + s.slice(1);
        })
        .join(" ");
      return finalOutput;
    },
  },
};
</script>
/*$(document).ready(function(){ $('.menuToggle').click(function(){
$('.sideFixed').toggleClass('active'); }) })*/
<style>
button.page-link {
  display: inline-block;
}

.icon {
  /* background:white; */
  color: #fff;
}

button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}

.offset {
  width: 500px !important;
  margin: 20px auto;
}

.nav-button {
  color: #427bb8;
  border: none;
  border-radius: 5px;
  background-color: #fff;
  padding: 6px 10px;
}

.nav-button:hover {
  color: #fff;
  background-color: #427bb8;
  cursor: pointer;
}

.z-index-10 {
  z-index: 10 !important;
}

.card-container {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
}
</style>
